export const a = []

export const MUSIC_LIST = [
  {
    author: '宝木中阳',
    text:
      '建党百年恰风华，青年奋斗正当时 心中有国，家中有爱 大家好，我是配音演员宝木中阳 我心中的家，是家人所在，永远温馨甜蜜 我认为的国，则是心之所向，共享文明和谐 和我一起守护温馨甜蜜的小家 共同建设文明和谐的大家',
    shareText: '家：家人所在；国：心之所向',
    src:
      'https://ugc.hitv.com/platform_oss/1623915777642/1、个性版（国家安全）.mp3',
  },
  {
    author: '宝木中阳',
    text:
      '新时代新挑战，新青年新发展 我是配音演员宝木中阳 我们个性十足也需要不忘脚踏实地 让我们为新发展格局奉献青年力量 建党百年恰风华，青年奋斗正当时',
    shareText: '让我们为新发展格局奉献青年力量',
    src:
      'https://ugc.hitv.com/platform_oss/1623915798484/2、个性版（新发展格局）.mp3',
  },
  {
    author: '陈张太康',
    text:
      '大家好，我是配音演员陈张太康 我们是时代的见证者，更是践行人 把握全球化机遇、迎接世界的挑战 建党百年恰风华，青年奋斗正当时',
    shareText: '全球化与当代青年：挑战、责任、理想',
    src:
      'https://ugc.hitv.com/platform_oss/1623915817236/3、个性版（全球化发展）.mp3',
  },
  {
    author: '陈张太康',
    text:
      '建党百年恰风华，青年奋斗正当时 大家好 我是配音演员陈张太康 百年光辉历程，初心不变 2035远景目标不仅是年轻一辈的个人愿望 也是中国未来发展的规划之一 从现在开始，和我一起共同努力吧',
    shareText: '百年光辉历程，初心不变，和我一起努力吧！',
    src:
      'https://ugc.hitv.com/platform_oss/1623915833243/4、个性版（远景目标）.mp3',
  },
  {
    author: '代云帆',
    text:
      '新时代新挑战，新青年新发展 我是代云帆 我们个性十足也需要不忘脚踏实地 让我们为新发展格局奉献青年力量 建党百年恰风华，青年奋斗正当时',
    shareText: '建党百年恰风华，青年奋斗正当时！',
    src:
      'https://ugc.hitv.com/platform_oss/1623915852607/5、个性版（新发展格局方向）.mp3',
  },
  {
    author: '郭俊辰',
    text:
      '建党百年恰风华，青春奋斗正当时 大家好，我是郭俊辰 百年大计，教育为本 以德育人、为党育人、为国育才 才能培育出新时代接班人',
    shareText: '百年大计，教育为本，我们是新时代接班人！',
    src:
      'https://ugc.hitv.com/platform_oss/1623915869292/6、个性版（教育强国方向）.mp3',
  },
  {
    author: '姜广涛',
    text:
      '近百年不忘初心、与时俱进 中国在党的领导下以改革创新为动力 高质量发展成效显著 我是姜广涛 建党百年恰风华，青年奋斗正当时 祝福祖国日益繁荣昌盛',
    shareText: '以改革创新书写高质量发展的时代答卷',
    src:
      'https://ugc.hitv.com/platform_oss/1623915886112/7、个性版（创新发展）.mp3',
  },
  {
    author: '姜广涛',
    text:
      '大家好，我是姜广涛 工匠精神是优秀中华传统文化 和人类文明的伟大结晶 是一种职业态度和精神理念 青年是时代的主角 更是“工匠精神”的继承者 建党百年恰风华，青年奋斗正当时',
    shareText: '青年是时代的主角，更是“工匠精神”的继承者',
    src:
      'https://ugc.hitv.com/platform_oss/1623915901964/8、个性版（工匠精神）.mp3',
  },
  {
    author: '李莎旻子',
    text:
      '大家好，我是李莎旻子 我们是时代的见证者，更是践行人 把握全球化机遇、迎接世界的挑战 建党百年恰风华，青年奋斗正当时',
    shareText: '把握全球化机遇，迎接世界的挑战！',
    src:
      'https://ugc.hitv.com/platform_oss/1623915921395/9、个性版（全球化发展方向）.mp3',
  },
  {
    author: '刘凯',
    text:
      '共命运、心连心 各民族携手共进 谱写民族团结篇章 我是演员刘凯 建党百年恰风华，青年奋斗正当时',
    shareText: '共命运、心连心，民族团结一家亲',
    src:
      'https://ugc.hitv.com/platform_oss/1623915938462/10、个性版（民族团结方向）.mp3',
  },
  {
    author: '马正阳',
    text:
      '对外开放的大门越开越大 实施高水平对外开放政策 人人都是受益者 我是马正阳 跟随党和国家的步伐 走向世界、了解世界 建党百年恰风华，青年奋斗正当时',
    shareText: '跟随党和国家的步伐，走向世界、了解世界',
    src:
      'https://ugc.hitv.com/platform_oss/1623915954229/11、个性版（对外开放）.mp3',
  },
  {
    author: '马正阳',
    text:
      '大家好，我是马正阳 有越来越多的青年人 用新潮的思想理念、先进的科学技术 为乡村振兴赋予蓬勃能量 我们理应为这些热血青年点赞 建党百年恰风华，青年奋斗正当时',
    shareText: '扬青春之帆，在乡村振兴中乘风破浪',
    src:
      'https://ugc.hitv.com/platform_oss/1623915973680/12、个性版（乡村振兴）.mp3',
  },
  {
    author: '齐思钧',
    text:
      '建党百年恰风华，青年奋斗正当时 大家好，我是齐思钧 百年光辉历程，初心不变 2035远景目标不仅仅是年轻一代的个人愿望 也是中国未来发展的规划之一 从现在开始，与我共同努力吧',
    shareText: '相约“2035”远景目标 迈大步“履约”前行',
    src:
      'https://ugc.hitv.com/platform_oss/1623915991801/13、个性版（远景目标方向）.mp3',
  },
  {
    author: '邵明明',
    text:
      '大家好，我是邵明明 乡村振兴，青年先行 乡村振兴的希望在于我们这代年轻人的奋斗 这是一份个人的抱负 也是一份家国的担当 建党百年恰风华，青年奋斗正当时',
    shareText: '乡村振兴，青年在行动',
    src:
      'https://ugc.hitv.com/platform_oss/1623916009863/14、个性版（乡村振兴方向）.mp3',
  },
  {
    author: '沈磊',
    text:
      '大家好，我是沈磊 传承百年红色基因，推动航天强国建设 是我们不懈追求的航天梦 对于中华儿女而言 应为航天强国建设贡献更多智慧和力量 建党百年恰风华，青年奋斗正当时',
    shareText: '传承百年红色基因，推动航天强国建设',
    src:
      'https://ugc.hitv.com/platform_oss/1623916028464/15、个性版（航空航天方向）.mp3',
  },
  {
    author: '沈磊',
    text:
      '建党百年恰风华，青年奋斗正当时 14亿中国人正坚定走在绿色发展之路上 我是沈磊 为子孙后代呵护一个 天蓝、地绿、水清的美好家园 从我做起',
    shareText: '一起呵护天蓝、地绿、水清的美好家园！	',
    src:
      'https://ugc.hitv.com/platform_oss/1623916044867/16、个性版（绿色转型方向）.mp3',
  },
  {
    author: '滕奎兴',
    text:
      '共命运、心连心 各民族携手共进 谱写民族团结篇章 我是滕奎兴 建党百年恰风华，青年奋斗正当时',
    shareText: '促进各民族共同团结、共同繁荣发展',
    src:
      'https://ugc.hitv.com/platform_oss/1623916059936/17、个性版（民族团结）.mp3',
  },
  {
    author: '滕奎兴',
    text:
      '实业兴邦，制造强国 越来越多青年人才在 科技创新的第一线“冒尖” 大家好，我是滕奎兴 建党百年恰风华，青年奋斗正当时 后浪们请接棒，以匠心敬党心 尽情创造出属于你们的精彩吧',
    shareText: '以匠心敬党心，尽情创造属于青年人的精彩吧！',
    src:
      'https://ugc.hitv.com/platform_oss/1623916074030/18、个性版（制造强国）.mp3',
  },
  {
    author: '小连杀',
    text:
      '建党百年恰风华，青年奋斗正当时 奋斗，方显青春本色 大家好，我是小连杀 不忘初心、牢记使命 我们都是敢追梦勇前进的新时代奋斗者',
    shareText: '我们都是敢追梦勇前进的新时代奋斗者！',
    src:
      'https://ugc.hitv.com/platform_oss/1623916089173/19、个性版（个人奋斗）.mp3',
  },
  {
    author: '小连杀',
    text:
      '求知不息，学而不止 提升信息素养，淬炼学习能力 拳拳赤子心向党，勤勤学习以报国 大家好，我是小连杀 建党百年恰风华，青年奋斗正当时 终身学习，从此刻开始',
    shareText: '拳拳赤子心向党，勤勤学习以报国',
    src:
      'https://ugc.hitv.com/platform_oss/1623916103160/20、个性版（终身学习）.mp3',
  },
  {
    author: '张耀',
    text:
      '共命运、心连心 各民族携手共进 谱写民族团结篇章 大家好，我是张耀 建党百年恰风华，青年奋斗正当时',
    shareText: '共命运、心连心，谱写民族团结篇章',
    src:
      '	https://ugc.hitv.com/platform_oss/1623916119333/21、个性版（民族团结）.mp3',
  },
  {
    author: '赵昭仪',
    text:
      '大家好，我是赵昭仪 建党百年恰风华，青年奋斗正当时 保家卫国，不是大张旗鼓的呼告 而是日常点滴的坚守 我们的言行谈吐、举止态度 都是爱国护国的最好体现 国家安全，你我共同守护',
    shareText: '国家安全在身边 青年争做“守护者”	',
    src:'https://ugc.hitv.com/platform_oss/1624689569595/赵昭仪.mp3',
  },
  {
    author: '丁当',
    text:
      '百年浪潮新激荡，正是扬帆搏浪时 我们以踌躇满志谱写时代华章 书写“硬核”青春 Hi，大家好，我是丁当 建党百年恰风华，青年奋斗正当时 让我们一起砥砺前行，踏浪青春',
    shareText: '百年浪潮新激荡，正是扬帆搏浪时',
    src:
      'https://ugc.hitv.com/platform_oss/1623916979300/23、个性版（青春向上）.mp3',
  },
  {
    author: '杨烁',
    text:
      '共命运、心连心 各民族携手共进 谱写民族团结篇章 我是杨烁 建党百年恰风华，青年奋斗正当时',
    shareText: '石榴花开情谊暖，民族团结一家亲',
    src:
      'https://ugc.hitv.com/platform_oss/1623917004626/24、个性版（民族团结）.mp3',
  },
  {
    author: '谷蓝帝',
    text:
      '建党百年恰风华，青年奋斗正当时 大家好，我是谷蓝帝 岁月无声，党有声 来芒果TV和我一起礼赞幸福美好新时代吧 百年风华，时代有我',
    shareText: '百年风华，时代有我',
    src: 'https://ugc.hitv.com/platform_oss/1624878313861/谷蓝帝.mp3',
  },
  {
    author: '王晨艺',
    text:
      '建党百年恰风华，青年奋斗正当时 奋斗，方显青春本色 大家好，我是王晨艺 不忘初心、牢记使命 我们都是敢追梦、勇前进的新时代奋斗者',
    shareText: '奋斗，方显青春本色',
    src: 'https://ugc.hitv.com/platform_oss/1624881231939/王晨艺ID.mp3',
  },
  {
    author: '魏晨',
    text:
      '大家好，我是魏晨 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '建党百年恰风华，青年奋斗正当时',
    src: 'https://ugc.hitv.com/platform_oss/1624959437856/魏晨ID(1).mp3',
  },
  {
    author: '大王',
    text:
      '大家好，我是大王 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '百年风华，时代有我',
    src: 'https://ugc.hitv.com/platform_oss/1624959487681/大王ID.mp3',
  },
  {
    author: '孟子义',
    text:
      '大家好，我是孟子义 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '建党百年恰风华，青年奋斗正当时',
    src: 'https://ugc.hitv.com/platform_oss/1624959501545/孟子义ID.mp3',
  },
  {
    author: '李响',
    text:
      '建党百年恰风华，青年奋斗正当时 大家好，我是李响（青年舞蹈家） 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '建党百年恰风华，青年奋斗正当时',
    src: 'https://ugc.hitv.com/platform_oss/1624959514950/李响1.mp3',
  },
  {
    author: '李响',
    text:
      '嫦娥揽月，天问奔火 航天梦是富强梦，更是民族梦 我是李响（青年舞蹈家） 从航天梦起到奔赴星河，你我共同见证 建党百年恰风华，青年奋斗正当时',
    shareText: '从航天梦起到奔赴星河，你我共同见证',
    src: 'https://ugc.hitv.com/platform_oss/1624959539509/李响2.mp3',
  },
  {
    author: '薛莹',
    text:
      '大家好，我是薛莹 (中航西飞国际航空部件厂铆装钳工) 传承百年红色基因，推动航空强国建设 是我们不懈追求的航空梦 对于中华儿女而言 应为航空强国建设贡献更多的智慧和力量 建党百年恰风华，青年奋斗正当时',
    shareText: '传承百年红色基因，推动航空强国建设',
    src: 'https://ugc.hitv.com/platform_oss/1624959857600/薛莹.mp3',
  },
  {
    author: '张玉花',
    text:
      '大家好，我是张玉花 （嫦娥五号、天问一号探测器副总指挥） 传承百年红色基因，推动航天强国建设 是我们不懈追求的航天梦 对于航天儿女而言 应为航天强国建设贡献更多的智慧和力量 建党百年恰风华，青年奋斗正当时',
    shareText: '传承百年红色基因，推动航天强国建设',
    src: 'https://ugc.hitv.com/platform_oss/1624959872415/张玉花.mp3',
  },
  {
    author: '余留芬',
    text:
      '大家好 我是余留芬（改革女先锋） 有越来越多青年人 用新潮的思想、理念，先进的科学、技术 为乡村振兴赋予蓬勃能量 我们理应为这些热血青年点赞 建党百年恰风华，青年奋斗正当时',
    shareText: '为乡村振兴赋予蓬勃能量',
    src: 'https://ugc.hitv.com/platform_oss/1624959880969/余留芬.mp3',
  },
  {
    author: '唐克丽',
    text:
      '大家好 我是唐克丽（土壤学专家） 我们是时代的见证者，更是践行人 把握全球化机遇，迎接世界的挑战 建党百年恰风华，青年奋斗正当时',
    shareText: '把握全球化机遇，迎接世界的挑战',
    src: 'https://ugc.hitv.com/platform_oss/1624959891115/唐克丽1.mp3',
  },
  {
    author: '唐克丽',
    text:
      '建党百年恰风华，青年奋斗正当时 十四亿中国人正坚定走在绿色发展之路上 我是唐克丽（土壤学专家） 为子孙后代呵护一个 天蓝、地绿、水清的美好家园 从我做起',
    shareText: '为子孙后代呵护一个天蓝、地绿、水清的美好家园',
    src: 'https://ugc.hitv.com/platform_oss/1624959899216/唐克丽2.mp3',
  },
  {
    author: '唐克丽',
    text:
      '近百年不忘初心、与时俱进 中国在党的领导下以改革创新为动力 高质量发展成效显著 我是唐克丽（土壤学专家） 建党百年恰风华，青年奋斗正当时 祝福祖国日益繁荣昌盛',
    shareText: '建党百年恰风华，青年奋斗正当时',
    src: 'https://ugc.hitv.com/platform_oss/1624959909105/唐克丽3.mp3',
  },
  {
    author: '何菲',
    text:
      '大家好，我是赵梦桃小组组长何菲 工匠精神是 优秀中华传统文化和人类文明的伟大结晶 是一种职业态度和精神理念 青年是时代的主角 更是“工匠精神”的继承者 建党百年恰风华，青年奋斗正当时',
    shareText: '青年是时代的主角，更是“工匠精神”的继承者',
    src: 'https://ugc.hitv.com/platform_oss/1624959921203/何菲.mp3',
  },
  {
    author: '杜诚诚',
    text:
      '建党百年恰风华，青春奋斗正当时 奋斗，方显青春本色 大家好，我是杜诚诚 （最美志愿者） 不忘初心、牢记使命 我们都是敢追梦、勇前进的新时代奋斗者',
    shareText: '我们都是敢追梦、勇前进的新时代奋斗者',
    src: 'https://ugc.hitv.com/platform_oss/1624959928860/杜诚诚.mp3',
  },
  {
    author: '刘端端',
    text:
      '大家好，我是刘端端 把初心和使命变成 开拓创新永不满足的精气神 和通力合作、敢于拼搏的实际行动 建党百年恰风华，青年奋斗正当时',
    shareText: '牢记初心使命，勇于开拓创新',
    src: 'https://ugc.hitv.com/platform_oss/1624961135596/刘端端 单人1版.mp3',
  },
  {
    author: '刘端端',
    text:
      '大家好，我是刘端端 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '百年风华，时代有我',
    src:
      'https://ugc.hitv.com/platform_oss/1624961145222/刘端端（共同版1）.mp3',
  },
  {
    author: '张馨予',
    text:
      '建党百年恰风华，青年奋斗正当时 大家好，我是张馨予 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '建党百年恰风华，青年奋斗正当时',
    src: 'https://ugc.hitv.com/platform_oss/1624961311337/张馨予.mp3',
  },
  {
    author: '朱莲香',
    text:
      '建党百年恰风华，青春奋斗正当时 奋斗方显青春本色 大家好，我是朱莲香（客运服务员） 不忘初心，牢记使命 我们都是敢追梦、勇前进的新时代奋斗者',
    shareText: '我们都是敢追梦、勇前进的新时代奋斗者',
    src: 'https://ugc.hitv.com/platform_oss/1624967241127/朱莲香.mp3',
  },
  {
    author: '韩利萍',
    text:
      '大家好，我是航天科技工作者韩利萍 （航天一院首席技能专家） 新时代，新征程 当前社会 迫切需要有中国特色的工匠精神职业人 时代也呼唤青年们肩负起技能报国的重任 建党百年恰风华，青春奋斗正当时',
    shareText: '践行工匠精神，抒写时代华章',
    src: 'https://ugc.hitv.com/platform_oss/1624967276828/韩利萍.mp3',
  },
  {
    author: '张月姣',
    text:
      '大家好，我是张月姣 （WTO上诉机构前主席） 百年铸就辉煌,我们国家的新征程已起航 未来对青年而言 意味着开启了新阶段新征程的奋斗之路 建党百年恰风华，青年奋斗正当时',
    shareText: '建党百年恰风华，青年奋斗正当时',
    src: 'https://ugc.hitv.com/platform_oss/1624967503929/张月姣1.mp3',
  },
  {
    author: '张月姣',
    text:
      '对外开放的大门越开越大 实施高水平对外开放政策，人人都是受益者 我是张月姣（WTO上诉机构前主席） 跟随党和国家的步伐走向世界，了解世界 建党百年恰风华，青年奋斗正当时',
    shareText: '携手同一世界，青年共创未来',
    src: 'https://ugc.hitv.com/platform_oss/1624968036113/张月姣2.mp3',
  },
  {
    author: '宝石Gem',
    alias: '董宝石',
    text:
      '建党百年恰风华，青年奋斗正当时 大家好，我是歌手董宝石 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '建党百年恰风华，青年奋斗正当时',
    src: 'https://ugc.hitv.com/platform_oss/1624968486546/宝石Gem.mp3',
  },
  {
    author: '龚琳娜',
    text:
      '大家好，我是龚琳娜 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '百年风华，时代有我',
    src: 'https://ugc.hitv.com/platform_oss/1624969302406/龚琳娜1.mp3',
  },
  {
    author: '龚琳娜',
    text:
      '大家好，我是龚琳娜 把初心和使命变成 开拓创新永不满足的精气神 和通力合作、敢于拼搏的实际行动',
    shareText: '牢记初心使命，勇于开拓创新',
    src: 'https://ugc.hitv.com/platform_oss/1624969313876/龚琳娜2.mp3',
  },
  {
    author: '朱婧汐',
    text:
      '大家好，我是朱婧汐 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '百年风华，时代有我',
    src: 'https://ugc.hitv.com/platform_oss/1624974134858/朱婧汐.mp3',
  },
  {
    author: '魏大勋',
    text:
      '建党百年恰风华，青年奋斗正当时 大家好，我是魏大勋 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '建党百年恰风华，青年奋斗正当时',
    src: 'https://ugc.hitv.com/platform_oss/1625564910812/魏大勋.mp3',
  },
  {
    author: '周延',
    text:
      '百年浪潮新激荡，正是扬帆搏浪时 我们以踌躇满志谱写时代华章 书写“硬核”青春 我是周延 建党百年恰风华，青年奋斗正当时 让我们一起砥砺前行，踏浪青春',
    shareText: '在接续奋斗中展现硬核青春',
    src: 'https://ugc.hitv.com/platform_oss/1625564932125/周延 青春向上.mp3',
  },
  {
    author: '周延',
    text:
      '建党百年恰风华，青年奋斗正当时 大家好，我是周延 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '百年风华，时代有我',
    src: 'https://ugc.hitv.com/platform_oss/1625564967614/周延 百年通用.mp3',
  },
  {
    author: '王安宇',
    text:
      '百年新起点，青春正当时 青年应将使命融入时代发展的洪流 书写无悔的青春华章 我是王安宇 建党百年恰风华，青年奋斗正当时',
    shareText: '以青春之名书写时代华章',
    src: 'https://ugc.hitv.com/platform_oss/1625566915771/王安宇(青年奋斗方向).mp3',
  },
  {
    author: '王安宇',
    text:
      '建党百年恰风华，青年奋斗正当时 大家好，我是王安宇 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '建党百年恰风华，青年奋斗正当时',
    src: 'https://ugc.hitv.com/platform_oss/1625567926208/王安宇（通用版本）.mp3',
  },
  {
    author: '高瀚宇',
    text:
      '建党百年恰风华，青年奋斗正当时 大家好，我是高瀚宇 岁月无声，党有声 在百年历史的无数声音中 让我们共同见证中国共产党的时代记忆 百年风华，时代有我',
    shareText: '百年风华，时代有我',
    src: 'https://ugc.hitv.com/platform_oss/1625568137198/高瀚宇（统一版）.mp3',
  },
  {
    author: '高瀚宇',
    text:
      '百年新起点，青春正当时 青年应将使命融入时代发展的洪流 书写无悔的青春华章 我是高瀚宇 建党百年恰风华，青年奋斗正当时',
    shareText: '建党百年恰风华，青年奋斗正当时',
    src: 'https://ugc.hitv.com/platform_oss/1625568177704/高瀚宇（青春向上方向）.mp3',
  },
]
